import { createReducer } from "../../../_common/common";
import { SET_TRANSFER_EXPEDIENT_STATUS} from "../actions/constants";

const initialState = {
    status: null,
}
export const transferExpedient = createReducer(initialState, {
    [SET_TRANSFER_EXPEDIENT_STATUS]: (state, payload) => {
        state.status = payload;
        return state
    }
});
